import React, { useState } from "react";
import {
  Box,
  Button,
  createStyles,
  Grid,
  makeStyles,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import _ from "lodash";
import WithLoading from "../../../../utils/WithLoading";
import { CustomTheme } from "../../../../types/customTheme";
import { handleDownloadPdf } from "./convert/handlePdf";
import { handleDownloadExcel } from "./convert/handleExcel";
import LocationDetailsCard from "../../../../components/common/LocationDetailsCard";
import MenuButtonCommon from "../../../../components/buttons/MenuButtonCommon";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Autocomplete } from "@material-ui/lab";
export interface ShiftHeaderProps {
  selectedRoleObj: any;
  handleChangeRole: any;
}

const useStyles = makeStyles((theme: any) =>
  createStyles({
    titleColor: {
      color: theme.palette.custom.orange.contrastText,
    },
    autoComplete: {
      marginTop: "4px",
      width: "200px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_highlight_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        borderRadius: 10,
        border: "none",
        color: theme.palette.custom.orange.contrastText,
      },
    },
  }),
);

const customerRoles = [
  { id: "all", label: "Sales Count & Total" },
  { id: "count", label: "Sales Count" },
  { id: "total", label: "Sales Total" },
];

/**
 * DropDown Component:
 *
 * This component handles the header section of the Shift component, including
 * sorting controls, location selection, and shift generation. It displays shift
 * information in a table-like format with sortable columns and provides options
 * for selecting shifts, generating reports, and handling user interactions.
 */
const DropDown: React.FunctionComponent<ShiftHeaderProps> = ({
  selectedRoleObj,
  handleChangeRole,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const theme: CustomTheme = useTheme();

  return (
    <Autocomplete
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      size={"small"}
      id="locationSelectGlobal"
      color="inherit"
      options={customerRoles}
      value={selectedRoleObj}
      getOptionLabel={(option: any) => option.label || ""}
      disableClearable
      onChange={handleChangeRole}
      classes={{ root: classes.autoComplete }}
      popupIcon={<ArrowDropDownIcon color={"inherit"} />}
      renderOption={(props: any) => {
        return (
          <Grid
            container
            {...props}
            style={{
              display: "flex",
              justifyContent: "space-between",
              zIndex: 0,
              height: "20px",
              marginBottom: "4px",
            }}
          >
            <Grid item xs={12}>
              <Typography variant="body2" className={classes.titleColor}>
                {props.label}
              </Typography>
            </Grid>
          </Grid>
        );
      }}
      renderInput={(params: any) => (
        <TextField
          color="inherit"
          {...params}
          label=""
          placeholder="Select"
          variant="outlined"
        />
      )}
    />
  );
};

export default DropDown;
